import { Set } from 'immutable';
import * as types from './types';
import { REMOVE_OBJECTS } from '../project/types';
import { createReducer } from '../utils';

const toggleObjectLock = ({ objectID }) => state => {
  if (state.has(objectID)) {
    return state.remove(objectID);
  }

  return state.add(objectID);
};

const removeObjects = ({ ids }) => state =>
  ids.reduce(
    (newState, removedID) =>
      newState.filterNot(objectID => removedID === objectID),
    state,
  );

const clearObjectsLock = () => () => Set();

const lockedObjectsReducer = createReducer(Set(), {
  [types.TOGGLE_OBJECT_LOCK]: toggleObjectLock,
  [REMOVE_OBJECTS]: removeObjects,
  [types.CLEAR_OBJECTS_LOCK]: clearObjectsLock,
});

export default lockedObjectsReducer;
